export const POSITION_OBTAINED = '@@mah-maps/POSITION_OBTAINED';
export const USER_POSITION_CHANGED = '@@mah-maps/USER_POSITION_CHANGED';
export const ZOOM_CHANGED = '@@mah-maps/ZOOM_CHANGED';
export const MAP_CENTER_CHANGED = '@@mah-maps/MAP_CENTER_CHANGED';